import { AnyAction } from 'redux';
import { DemandTopicStatus } from '@synergy/models';
import { PaginatedResponse } from '@synergy/api';
import { defaultPageSize } from '@synergy/config';

import {
    DEMANDS_TOPICS_ASSIGN_CONTACTS,
    DEMANDS_TOPICS_CHANGE_INTEREST,
    DEMANDS_TOPICS_RECEIVED,
    DEMANDS_TOPICS_REQUESTED,
    DEMANDS_TOPICS_RESET,
} from './demands-topics-actions';
import { DemandTopicsListItem } from '../models/demand-topics-list-item';

export interface DemandTopicsReducerState {
    data: PaginatedResponse<DemandTopicsListItem>;
    requesting: boolean;
}

const initialDemandTopicsReducerState: DemandTopicsReducerState = {
    data: { items: [], total: 0, page: 1, limit: defaultPageSize },
    requesting: false,
};

export const demandsTopicsReducer = (
    state: DemandTopicsReducerState = initialDemandTopicsReducerState,
    action: AnyAction
): DemandTopicsReducerState => {
    const { type, ...rest } = action;
    switch (type) {
        case DEMANDS_TOPICS_REQUESTED: {
            return {
                ...state,
                requesting: true,
            };
        }

        case DEMANDS_TOPICS_RECEIVED: {
            return {
                ...state,
                data: rest['topics'],
                requesting: false,
            };
        }

        case DEMANDS_TOPICS_RESET: {
            return {
                ...state,
                data: initialDemandTopicsReducerState.data,
            };
        }

        case DEMANDS_TOPICS_ASSIGN_CONTACTS: {
            const { topicId, contacts } = rest;
            const nextItems = [...state.data.items];
            const item = nextItems.find(item => item.id === topicId);
            if (item) {
                item.contacts = contacts;
                item.status = contacts.length > 0 ? DemandTopicStatus.Assigned : DemandTopicStatus.Unassigned;
            }
            return {
                ...state,
                data: {
                    ...state.data,
                    items: nextItems,
                },
            };
        }

        case DEMANDS_TOPICS_CHANGE_INTEREST: {
            const { topicId, interest } = rest;
            const nextItems = [...state.data.items];
            const item = nextItems.find(item => item.id === topicId);
            if (item) {
                item.status = interest ? DemandTopicStatus.Unassigned : DemandTopicStatus.NotInterested;
                item.contacts = [];
            }

            return {
                ...state,
                data: {
                    ...state.data,
                    items: nextItems,
                },
            };
        }

        default: {
            return state;
        }
    }
};
